import moment from 'moment';

export const DATE_FORMATS = [
  moment.ISO_8601, // e.g. 2024-10-01T00:00:00
  'MM/DD/YYYY:HH:mm:ss', // e.g. 10/01/2024:00:00:00
  'MM/DD/YYYY HH:mm:ss', // e.g. 10/01/2024 00:00:00
  'MM-DD-YYYY:HH:mm:ss', // e.g. 10-01-2024:00:00:00
  'MM-DD-YYYY HH:mm:ss', // e.g. 10-01-2024 00:00:00
  'MM/DD/YYYY', // e.g. 10/01/2024
  'MM-DD-YYYY' // e.g. 10-01-2024
];
